// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"c262b4a8","591":"5afe7481","687":"c85e8401","781":"14b6a6bc","852":"fb673710"}[chunkId] + ".chunk.css";
};